/* tslint:disable */
/* eslint-disable */
/**
 * Product Page Aggregator
 * Aggregator for the product page on web and native apps
 *
 * The version of the OpenAPI document: 1
 * Contact: mark.salt@autotrader.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { AdvertFromJSON, } from '../models/index';
/**
 *
 */
export class ControllerApi extends runtime.BaseAPI {
    /**
     * Get advert
     */
    getAdvertRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['advertId'] == null) {
                throw new runtime.RequiredError('advertId', 'Required parameter "advertId" was null or undefined when calling getAdvert().');
            }
            if (requestParameters['channel'] == null) {
                throw new runtime.RequiredError('channel', 'Required parameter "channel" was null or undefined when calling getAdvert().');
            }
            const queryParameters = {};
            if (requestParameters['channel'] != null) {
                queryParameters['channel'] = requestParameters['channel'];
            }
            if (requestParameters['version'] != null) {
                queryParameters['version'] = requestParameters['version'];
            }
            const headerParameters = {};
            if (requestParameters['xProductPageTracking'] != null) {
                headerParameters['X-Product-Page-Tracking'] = String(requestParameters['xProductPageTracking']);
            }
            if (requestParameters['xServerSideTracking'] != null) {
                headerParameters['X-Server-Side-Tracking'] = String(requestParameters['xServerSideTracking']);
            }
            if (requestParameters['xAtProfileSegments'] != null) {
                headerParameters['X-At-Profile-Segments'] = String(requestParameters['xAtProfileSegments']);
            }
            const response = yield this.request({
                path: `/product-page/v1/advert/{advertId}`.replace(`{${"advertId"}}`, encodeURIComponent(String(requestParameters['advertId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AdvertFromJSON(jsonValue));
        });
    }
    /**
     * Get advert
     */
    getAdvert(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAdvertRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
